module.exports = __webpack_public_path__ + "static/enchanted-pond1-440889da4fdff0ed21f4671ecca81936.jpg";